import React, { useState } from "react";
import { Button } from "../Button";
import { useDispatch } from "react-redux";
import {
  setErrorMessage,
  setSuccessMessage,
} from "../../Redux/Slices/alert.slice";
import { parseApiError } from "../../Helper/apiError.helper";
import { ResultForm } from "./ResultForm";
import { useAddResult } from "../../hooks/resultsHooks/results.hooks";
import { validateResultData } from "../../Helper/validation/resultData.validation.helper";

export const AddResult = () => {
  const dispatch = useDispatch();

  const [resultLabel, setResultLabel] = useState("");
  const [resultCode, setResultCode] = useState("");
  const [schoolBranchId, setSchoolBranchId] = useState<number | null>(null);
  const [selectedClass, setSelectedClass] = useState<number | null>(null);
  const [publishDate, setPublishDate] = useState("");

  const resetResultState = () => {
    setResultLabel("");
    setResultCode("");
    setSchoolBranchId(null);
    setSelectedClass(null);
    setPublishDate("");
  };

  const { isLoading: isSavingResult, mutate: addResult } = useAddResult({
    onSuccess: () => {
      dispatch(setSuccessMessage("Branch added successfully."));
      resetResultState();
    },
    onError: (error: any) => {
      dispatch(setErrorMessage(parseApiError(error)));
    },
  });

  const handleAddResult = () => {
    if (
      !validateResultData(
        {
          resultLabel,
          resultCode,
          schoolBranchId,
        },
        dispatch
      )
    ) {
      return;
    }

    addResult({
      label: resultLabel,
      code: resultCode,
      school_branch_id: schoolBranchId as number,
      class_id: selectedClass as number,
      publish_date: publishDate,
    });
  };

  return (
    <div>
      <div>
        <ResultForm
          resultLable={resultLabel}
          setResultLabel={setResultLabel}
          resultCode={resultCode}
          setResultCode={setResultCode}
          schoolBranchId={schoolBranchId}
          onBranchSelect={(branchId) => {
            if (branchId) {
              setSchoolBranchId(branchId);
            }
          }}
          selectedClass={selectedClass}
          onClassSelect={(classId) => {
            if (classId) {
              setSelectedClass(classId);
            }
          }}
          publishDate={publishDate}
          setPublishDate={setPublishDate}
        />
      </div>
      <div>
        <Button
          loading={isSavingResult}
          text="Save"
          onClick={handleAddResult}
        />
      </div>
    </div>
  );
};
